/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ActivityFull } from './ActivityFull';
import {
    ActivityFullFromJSON,
    ActivityFullFromJSONTyped,
    ActivityFullToJSON,
} from './ActivityFull';
import type { PlaylistFull } from './PlaylistFull';
import {
    PlaylistFullFromJSON,
    PlaylistFullFromJSONTyped,
    PlaylistFullToJSON,
} from './PlaylistFull';

/**
 * 
 * @export
 * @interface CollectionActivityFull
 */
export interface CollectionActivityFull extends ActivityFull {
    /**
     * 
     * @type {string}
     * @memberof CollectionActivityFull
     */
    itemType: CollectionActivityFullItemTypeEnum;
    /**
     * 
     * @type {PlaylistFull}
     * @memberof CollectionActivityFull
     */
    item: PlaylistFull;
}


/**
 * @export
 */
export const CollectionActivityFullItemTypeEnum = {
    Playlist: 'playlist'
} as const;
export type CollectionActivityFullItemTypeEnum = typeof CollectionActivityFullItemTypeEnum[keyof typeof CollectionActivityFullItemTypeEnum];


/**
 * Check if a given object implements the CollectionActivityFull interface.
 */
export function instanceOfCollectionActivityFull(value: object): value is CollectionActivityFull {
    let isInstance = true;
    isInstance = isInstance && "itemType" in value && value["itemType"] !== undefined;
    isInstance = isInstance && "item" in value && value["item"] !== undefined;

    return isInstance;
}

export function CollectionActivityFullFromJSON(json: any): CollectionActivityFull {
    return CollectionActivityFullFromJSONTyped(json, false);
}

export function CollectionActivityFullFromJSONTyped(json: any, ignoreDiscriminator: boolean): CollectionActivityFull {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...ActivityFullFromJSONTyped(json, ignoreDiscriminator),
        'itemType': json['item_type'],
        'item': PlaylistFullFromJSON(json['item']),
    };
}

export function CollectionActivityFullToJSON(value?: CollectionActivityFull | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...ActivityFullToJSON(value),
        'item_type': value.itemType,
        'item': PlaylistFullToJSON(value.item),
    };
}

